import app from '../app';

class PaymentFieldsService {

    /*@ngInject*/
    constructor(formlyFieldsService) {
        this.formlyFieldsService = formlyFieldsService;
    }

    getFields() {
        return [];
    }
}

app.service("paymentFieldsService", PaymentFieldsService);


// WEBPACK FOOTER //
// ./static/js/app/services/payment-fields.service.js